import UserDeposit from 'components/UserDeposit/UserDeposit';

const UserDepositPage = () => {
	return <UserDeposit />;
};

export default UserDepositPage;
